var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCodeCommit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M632 248H455.191C450.957 176.785 392.246 120 320 120S189.043 176.785 184.809 248H8C3.578 248 0 251.594 0 256S3.578 264 8 264H184.809C189.043 335.215 247.754 392 320 392S450.957 335.215 455.191 264H632C636.422 264 640 260.406 640 256S636.422 248 632 248ZM320 376C253.828 376 200 322.156 200 256S253.828 136 320 136S440 189.844 440 256S386.172 376 320 376Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeCommit);
export default __webpack_public_path__ + "static/media/code-commit.b6083ca79d6fa19fc6314fd5612e9758.svg";
export { ForwardRef as ReactComponent };